import { db, storage } from "../../common/config/Firebase"

const taskCollection = db.collection('tasks')
const taskDetailCollection = db.collection('tasksDetail')

export const saveTask = task => {
    return taskCollection.add(task)
}

export const updateTask = task => {
    return taskCollection.doc(task.id).set(task)
}

export const addFlagObservation = (id, flag) => {
    return taskCollection.doc(id).update({ observations: flag })
}

export const addPDFSign = (id, url) => {
    return taskCollection.doc(id).update({ docSign: url })
}

export const deleteTask = id => {
    return taskCollection.doc(id).delete()
}

export const updateTaskDetail = (id, detail) => {
    return taskDetailCollection.doc(id).set(detail)
}

export const updateParamsBudget = (id, refill, manPower) => {
    return taskDetailCollection.doc(id).update({ refill, manPower })
}

export const findTasksByReference = reference => {
    return taskCollection.where('reference', '==', reference).get()
}

export const findTasksByDni = dni => {
    return taskCollection.where('dni', '==', dni).get()
}

export const findDetailTaskById = reference => {
    return taskDetailCollection.doc(reference).get()
}

export const findTasksWithLimitAndOrder = (limit, orderField, orderType, setData) => {
    return taskCollection
        .orderBy(orderField, orderType)
        .orderBy("dateEntry", "desc")
        .limit(limit)
        .onSnapshot({ includeMetadataChanges: true }, setData);
}

export const getImageDetailRef = (id, name) => {
    let strRef = storage.ref();
    let imageRef = strRef.child(`${id}/imageDetail/${name}`);

    return imageRef;
}

export const getSignatureRef = (id) => {
    let strRef = storage.ref();
    let signatureRef = strRef.child(`${id}/signature`);

    return signatureRef;
}